import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function InvoicesGeneratedProvider({ children }) {
  useInjectSaga({ key: 'invoicesGeneratedProvider', saga });
  useInjectReducer({ key: 'invoicesGeneratedProvider', reducer });

  return React.Children.only(children);
}

InvoicesGeneratedProvider.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withInvoicesGenerated } from './withInvoicesGenerated';
export default compose(withConnect, memo)(InvoicesGeneratedProvider);
